<template>
    <div class="breadcrumb-ms" v-if="onRouter">
        <router-link to="/">
            <span class="breadcrumb-ms__item">Главная</span> 
        </router-link>
        <svg width="6" height="10" viewBox="0 0 6 10" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1 9L5 5L1 1"  stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        <template  v-for="(item,index) in route.matched" :key="item.id">
            <span class="breadcrumb-ms__item">
                <router-link :to="index!=route.matched.length-1?'/'+path(item.path):''" :class="index==$route.matched.length-1?'breadcrumb-ms__item_active':''">
                    {{item.name}}
                </router-link>
            </span>
             <svg v-if="index!=route.matched.length-1" width="6" height="10" viewBox="0 0 6 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M1 9L5 5L1 1"  stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
        </template>
    </div>
    <div class="breadcrumb-ms" v-if="!onRouter">
        <span class="breadcrumb-ms__item">
            <router-link to="/">
                Главная
            </router-link>
        </span>
        <svg width="6" height="10" viewBox="0 0 6 10" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1 9L5 5L1 1"  stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        <template  v-for="(item,index) in itemPath" :key="item.id">
            <span class="breadcrumb-ms__item">
                <router-link :to="index!=itemPath.length-1?'/'+path(item.link):''" :class="index==itemPath.length-1?'breadcrumb-ms__item_active':''">
                    {{item.label}}
                </router-link>
            </span>
             <svg v-if="index!=itemPath.length-1" width="6" height="10" viewBox="0 0 6 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M1 9L5 5L1 1"  stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg> 
        </template>
    </div>
</template>
<script>

export default{
    watch:{
        $route(e){
            this.route = e
        }
    },
    mounted(){
        this.route =this.$route
        console.log(this.$route)
    },
    methods:{
        path(text){
            return text.replace(/^[//]+|[//]+$/g, "") 
        }
    },
    props:{
        onRouter:{type:Boolean,default:true},
        itemPath:{type:Array}
    },
    data(){
        return{
            route:{}
        }
    }
}
</script>
<style>
    .breadcrumb-ms{
        align-items: center;
        display: flex;
        gap: 8px;
    }
    .breadcrumb-ms svg{
        stroke:#0D3041;
    }
    .panel .breadcrumb-ms a,
    .breadcrumb-ms a{
        color:#174E72 ;
        font-size: 16px;
        text-decoration: none;
    }
    .panel .breadcrumb-ms a:hover,
    .breadcrumb-ms a:hover{
        color:#007BB8 ;
    }
    .panel .breadcrumb-ms__item,
    .breadcrumb-ms__item{
        display: block;
        cursor: pointer;
    }
    .panel a.breadcrumb-ms__item_active,
    a.breadcrumb-ms__item_active{
        cursor: default;
        color: #919191;
    }
    .panel a.breadcrumb-ms__item_active:hover{
        color: #919191;
    }
</style>